import { AppService } from "./../../../app.service";
import {
    ChangeDetectorRef,
    ElementRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-about-aside",
    templateUrl: "./about-aside.component.html",
    styleUrls: ["./about-aside.component.scss"],
})
export class AboutAsideComponent implements OnInit, OnDestroy {
    selectedItem: string = "";
    items = [
        { Name: "History", Url: "history" },
        { Name: "Saint Gregory", Url: "saint-gregory" },
         { Name: "The Legend Gregorian's", Url: "the-legend-gregorian" },
          { Name: "Vision & Mission", Url: "mission-and-vision" },
        { Name: "Why Study Here", Url: "why-study" },
        { Name: "News & Events", Url: "news-and-events" },
        { Name: "Overview", Url: "overview" },
        { Name: "Holly Cross Brothers", Url: "holly-cross-brothers" },
        { Name: "Institute Discipline", Url: "institute-discipline" },
        { Name: "Building & Compunds", Url: "building-compunds" },
        { Name: "Culture", Url: "culture" },
       
        
    ];
    imageLoaded = false;
    fetchinData = true;
    ImageAlbums: any;
    GBs: any;
    GBs1: any;
    GBs2: any;
    TeacherInfo: any;
    GBms: any;
    GBms1: any;
    selectedItemName = "";
    showFullContent = false;
    showFullOverview = false;
    showFullWhy = false;
    showFullIns = false;
    showFullBuilding = false;
    showFullCulture = false;
    private ngUnsubscribe = new Subject();
    AboutUs: any;
    mission_data: any;
    vision_data: any;
    news: any;
    why_std: any;
    infus: any;
    histry: any;
    at_a_glance: any;
    oath_data: any;
    achievements: any;
    Mission_vision: any;
    Sant_gregory: any;
    legend_data: any;
    leged_info: any;
    value_of_legends: any;
    AboutGbs: any;
    legends_data: any;
    News_event_data: any;
    overview_data: any;
    holly_cross_data: any;
    institute_discipline_data: any;
    Building_Compunds_data: any;
    culture_data: any;
    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}
    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const item = params.get("item");
            const matchedItem = this.items.find((i) => i.Url === item);
            if (item && matchedItem && item == matchedItem.Url) {
                this.selectedItem = item;
                this.selectedItemName = matchedItem.Name;
            } else {
                this.selectedItem = this.items[0].Url;
                this.selectedItemName = this.items[0].Name;
                this.location.replaceState(`/${this.selectedItem}`);
            }
            this.FetchData();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
    FetchData() {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        if (
            this.selectedItem === "history" ||
            this.selectedItem === "why-study" ||
            this.selectedItem == "mission-and-vision" ||
            this.selectedItem == "saint-gregory" ||
            this.selectedItem == "the-legend-gregorian" ||
            this.selectedItem == "news-and-events" || 
              this.selectedItem == "overview" ||
                this.selectedItem == "holly-cross-brothers" ||
                  this.selectedItem == "institute-discipline" ||
                    this.selectedItem == "building-compunds" ||
                      this.selectedItem == "culture" 
        ) {
            this.About_data();
        } 
    }

    About_data() {
        forkJoin([this.appService.getContents(), this.appService.getGBs()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "All Response For About Us");

                this.AboutUs = response[0].data;
                this.AboutGbs = response[1].data;

                if (this.AboutUs != null) {
                    // History
                    let hostory = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "History"
                    );
                    this.histry = hostory[0];
                    console.log(this.histry, "History");
                    // Why Study
                    let why_study = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Why Study Here"
                    );
                    this.why_std = why_study[0];
                    console.log(this.why_std, "Why Study Data");
                    // Why Mision
                    let mission_vision = this.AboutUs.filter(
                        (x) => x.ContentCategoryName ==  "Vision & Mission"
                    );
                    this.mission_data = mission_vision[0];
                    console.log(this.mission_data, "Mission Data");
                    // Sain Gregory
                    let saintn_gregory = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Saint Gregory"
                    );
                    this.Sant_gregory = saintn_gregory[0];
                    console.log(this.why_std, "saintn gregory");
                    // Legend Gregory
                    let legends = this.AboutGbs.filter(
                        (x) => x.GBDesignation == "Legend Gregorian's"
                    );
                    this.legends_data = legends;
                    console.log(this.legends_data, "Legends Data");
                    // News and Events Data
                    let news = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "News And Events"
                    );
                    this.News_event_data = news;
                    console.log(this.News_event_data, "News event data Data");


                    
// Overview 
                    let overview = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Overview"
                
                    );
                    this.overview_data = overview[0];
                    console.log(this.overview_data, "Overview Data");

//Holy Cross Brothers
let holly_cross = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Holly Cross Brothers"
                
                    );
                    this.holly_cross_data = holly_cross[0];
                    console.log(this.holly_cross_data, "holly Cross Data");

//Institute Discipline 
let institute_discipline = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Institute Discipline"
                
                    );
                    this.institute_discipline_data = institute_discipline[0];
                    console.log(this.institute_discipline_data, "holly Cross Data"); 

//Building Compunda 
let Building_Compunds = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Building and Compounds"
                
                    );
                    this.Building_Compunds_data = Building_Compunds[0];
                    console.log(this.Building_Compunds_data, "holly Cross Data");
//Culture 
let culture = this.AboutUs.filter(
                        (x) => x.ContentCategoryName == "Culture"
                
                    );
                    this.culture_data = culture[0];
                    console.log(this.culture_data, "holly Cross Data");
                }
                this.fetchinData = false;
            });
    }
        selectItem(item: string) {
        this.selectedItem = item;
        const matchedItem = this.items.find((i) => i.Url === item);
        this.selectedItemName = matchedItem.Name;
        if (this.selectedItem === "history") {
            this.location.go(`/about/${item}`);
        } else if (this.selectedItem === "why-study") {
            this.location.go(`/about/${item}`);
        } else if (this.selectedItem === "mission-&-vision") {
            this.location.go(`/about/${item}`);
        } else if (this.selectedItem === "saint-gregory") {
            this.location.go(`/about/${item}`);
        } else if (this.selectedItem === "the-legend-gregorian") {
            this.location.go(`/about/${item}`);
        }
         else if (this.selectedItem === "news-and-events") {
            this.location.go(`/about/${item}`);
        }

else if (this.selectedItem === "overview") {
            this.location.go(`/about/${item}`);
        }
        else if (this.selectedItem === "holly-cross-brothers") {
            this.location.go(`/about/${item}`);
        }
        else if (this.selectedItem === "institute-discipline") {
            this.location.go(`/about/${item}`);
        }
        else if (this.selectedItem === "building-compunds") {
            this.location.go(`/about/${item}`);
        }
        else if (this.selectedItem === "culture") {
            this.location.go(`/about/${item}`);
        }

        else {
            this.location.go(`/about/achievements`);
        }
    }
    // Test truncate starts
   truncateText(text, maxLength) {
    // Check if the text length is greater than the maximum length
    if (text.length > maxLength) {
      // Truncate the text to the maximum length and append "..." at the end
      return text.substring(0, maxLength) + "...";
    } else {
      // If the text length is within the maximum length, return the original text
      return text;
    }
  }
    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }
}
